import React from 'react'
import Codepage from '../components/Codepage/Codepage'

function Code() {
  return (
    <div>
        <Codepage/>
      
    </div>
  )
}

export default Code
